export enum LayerType {
  data = 'data',
  indexes = 'indexes',
  build = 'build',
}

export default LayerType;
